import { EmptyComponent } from "../../common/EmptyComponent.js";
import Loadable from "react-loadable";

export const ControlCenterMiniLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "control-center/mini" */ "./ControlCenter.mini.js"
    ),
  loading: EmptyComponent
});

export const ControlCenterHeaderButtonLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "control-center/header-button" */ "./ControlCenter.headerButton.js"
    ),
  loading: EmptyComponent
});

export const ControlCenterDataLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "control-center/data" */ "./ControlCenter.data.js"
    ),
  loading: EmptyComponent
});

export * from "./ControlCenter.factory.js";
